import { registerPlugin } from "./utils/registerPlugin"

type ILoggerPlugin = {
  logToDetailLog: (payload: {
    message: string
  }) => Promise<void>
}

// const TAG = "TP+ JS Layer"

export const ILogger = registerPlugin<ILoggerPlugin>(
  "ILoggerPlugin",
  {
    logToDetailLog: async () => {
      // console.warn(`${TAG} : ${message}`)
    },
  }
)
